import { render, staticRenderFns } from "./StyleType.vue?vue&type=template&id=21a6a53b"
import script from "./StyleType.vue?vue&type=script&lang=js"
export * from "./StyleType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports